// extracted by mini-css-extract-plugin
export default {"ApplicationName":"_ApplicationName--CsxUI","InstallHeader":"_InstallHeader--Tadii"};